import { Pipe, PipeTransform } from '@angular/core';
import { DisplaySourceType } from '../shareModel';

@Pipe({
  standalone: false,
  name: 'displaySourceTypeCode'
})
export class DisplaySourceTypeCodePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (DisplaySourceType.hasOwnProperty(value)) {
      if (args === 'Type') {
        return DisplaySourceType[value].Type;
      } else if (args === 'SubType') {
        return DisplaySourceType[value].SubType;
      }
    }
    return null;
  }

}
